import {
  Box,
  Button,
  Grid,
  List,
  Stack,
  Fade,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

// Components
import Pageheader from "../common/Pageheader";
import Emptydata from "../common/Emptydata";
import Loader from "../../common/Loader";
import GoalListAndEdit from "./GoalListAndEdit";
import TimesheetCard from "./components/TimesheetCard";

// Modal Components
import SendTimesheet from "./models/SendTimesheet";
import TimesheetViewModal from "./models/TimesheetViewModal";
import AddEditTimesheetModel from "./AddEditTimesheetModel";
import GoalsList from "./models/GoalsList";
import AddClockIn from "./models/AddClockIn";
import AddGoalModal from "./models/AddGoalModal";
import Joblist from "./Joblist";
import ExportGoalsSummaryModal from "./models/ExportGoalsSummaryModal";
import PictureViewer from "../common/PictureViewer";

// Utils and API
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { Getrequestcall } from "../../request/Getrequest";
import {
  FETCH_GOALS,
  FETCH_TIMESHEETS,
  GET_TIMESHEETGOAL_DETAIL,
  GET_USER_DASHBOARD,
  UPDATE_IS_GOAL_FLAG,
  UPDATE_IS_TIMESHEETS_BANNER_FLAG
} from "../../constant/Apipath";
import {
  buildTimesheetRequestPayload,
  buildGoalRequestPayload,
  sortTimesheetData,
  formatGoalsArray,
  updateGoalInJobArray
} from "./utils/timesheetUtils";
import { BIBlue } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
import "./Timesheets.css";
import AdContainer from "../common/AdContainer";

export default function Timesheets() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Redux selectors
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);

  // ✅ KEEP: Core states that are used across multiple modals
  const [timeSheetlist, setTimesheetlist] = useState([]);
  const [activeList, setActivelist] = useState("all");
  const [loading, setLoading] = useState(false);
  const [selectedTimesheets, setSelectedTimesheets] = useState([]);
  const [seletetdTimesheet, setSeletetdTimesheet] = useState(null);

  // ✅ KEEP: Goal states (shared across components)
  const [userGoalData, setUserGoalData] = useState([]);
  const [goallist, setGoallist] = useState([]);
  const [loadingGoal, setLoadingGoal] = useState(false);
  const [isHideCompletedGoals, setIsHideCompletedGoals] = useState(false);
  const [isProgressBarExpanded, setIsProgressBarExpanded] = useState(false);
  const [isTimeSheetsBannerFlag, setIsTimeSheetsBannerFlag] = useState(false);

  // ✅ FIXED: Add initial loading state for first-time load
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  // ✅ KEEP: Job data (used by multiple forms)
  const [selectedJob, setSelectedJob] = useState([]);
  const [selectedClockInJob, setSelectedClokInJob] = useState([]);
  const [seletetdClockInTimesheet, setSeletetdClockINTimesheet] = useState(null);
  const [operation, setOperation] = useState("add");
  const [initialUser, setInitialUser] = useState();
  const [isClockIn, setIsClockin] = useState(false);

  // ✅ KEEP: Modal states (coordinate between components)
  const [showSend, setShowsend] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openClockIn, setOpenClockIn] = useState(false);
  const [showGoalModal, setShowGoalModal] = useState(false);
  const [showJoblist, setShowJoblist] = useState(false);
  const [showAddGoalModal, setShowAddGoalModal] = useState(false);
  const [currentEditGoal, setCurrentEditGoal] = useState(null);
  const [editGoalModal, setEditGoalModal] = useState(false);

  // ✅ KEEP: Form coordination state
  const [goalIndex, setGoalIndex] = useState(0);
  const [indexForGoal, setIndexForGoal] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState();

  // UI state
  const [anchorEl, setAnchorEl] = useState(null);
  const [isContext, setIsContext] = useState(false);
  const [imageArray, setImageArray] = useState([]);
  const [pictureViewerOpen, setPictureViewer] = useState(false);
  const [imageIndex, setImageIndex] = useState(null);

  const [deletedEntries, setDeletedEntries] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [deletedGoalsCategories, setDeletedGoalsCategories] = useState([]);

  // Language data
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_TIMESHEETS_TITLE = English.TimeSheet.TEXT_TIMESHEETS_TITLE,
    TEXT_ALL = English.TimeSheet.TEXT_ALL,
    TEXT_SENT = English.TimeSheet.TEXT_SENT,
    TEXT_UNSENT = English.TimeSheet.TEXT_UNSENT,
    BUTTON_ADD_TIMESHEET = English.TimeSheet.BUTTON_ADD_TIMESHEET,
    BUTTON_SEND = English.TimeSheet.BUTTON_SEND,
    TEXT_IN_PROGRESS = English.TimeSheet.TEXT_IN_PROGRESS,
    TEXT_EMPTY_TIMESHEETS_PLACEHOLDER = English.TimeSheet.TEXT_EMPTY_TIMESHEETS_PLACEHOLDER,
    TEXT_NEW_TIMESHEET = English.TimeSheet.TEXT_NEW_TIMESHEET,
    TEXT_ADD_CLOCKIN = English.TimeSheet.TEXT_ADD_CLOCKIN
  } = LanguageData || {};

  const open = Boolean(anchorEl);
  const retrievedData = JSON.parse(localStorage.getItem("clockInProgressData")) || [];

  // ✅ FIXED: Updated API functions to not control individual loading states during initial load
  const fetchTimesheets = useCallback(
    async (flag, isInitialLoad = false) => {
      try {
        if (!isInitialLoad) {
          setLoading(true);
        }
        const payload = buildTimesheetRequestPayload(flag, loginData?.userInformation?.UserId);
        const response = await Postrequestcall(FETCH_TIMESHEETS, payload, loginData?.accessToken);

        if (response?.status === 200) {
          const sortedData = sortTimesheetData(response.data.data);
          setTimesheetlist(sortedData);
        }

        if (!isInitialLoad) {
          setLoading(false);
        }
      } catch (error) {
        if (!isInitialLoad) {
          setLoading(false);
        }
        console.error("fetchTimesheets-> Error:", error);
      }
    },
    [loginData?.userInformation?.UserId, loginData?.accessToken]
  );

  const getUsersGoal = useCallback(
    async (isInitialLoad = false) => {
      try {
        const requestPayload = buildGoalRequestPayload(loginData?.userInformation?.UserId);
        const response = await Postrequestcall(FETCH_GOALS, requestPayload, loginData?.accessToken);
        if (response?.data?.data) {
          setUserGoalData(formatGoalsArray(response.data.data));
        }
      } catch (error) {
        console.error("getUsersGoal-> Error:", error);
      }
    },
    [loginData?.userInformation?.UserId, loginData?.accessToken]
  );

  const getTimesheetgoaldetail = useCallback(
    async (isInitialLoad = false) => {
      try {
        const response = await Getrequestcall(
          `${GET_TIMESHEETGOAL_DETAIL}/${loginData?.userInformation?.UserId}`,
          loginData?.accessToken
        );
        if (response.status === 200) {
          setGoallist(response?.data?.data);
        }
      } catch (error) {
        console.log("getTimesheetgoaldetail-> Error:", error);
      }
    },
    [loginData?.userInformation?.UserId, loginData?.accessToken]
  );

  // ✅ FIXED: Load all data with unified loading state
  const loadAllInitialData = useCallback(async () => {
    if (!loginData?.userInformation?.UserId) return;

    try {
      setIsInitialLoading(true);

      // ✅ Call all APIs simultaneously and wait for all to complete
      await Promise.all([
        fetchTimesheets("all", true),
        getUsersGoal(true),
        getTimesheetgoaldetail(true)
      ]);
    } catch (error) {
      console.error("loadAllInitialData-> Error loading initial data:", error);
    } finally {
      setIsInitialLoading(false);
    }
  }, [fetchTimesheets, getUsersGoal, getTimesheetgoaldetail, loginData?.userInformation?.UserId]);

  const getTimeSheetGoalFlag = async () => {
    try {
      const res = await Getrequestcall(`${GET_USER_DASHBOARD}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (res?.status === 200 && res?.data?.data) {
        setIsTimeSheetsBannerFlag(res?.data?.data?.isTimeSheetsBannerFlag);
      }
    } catch (error) {
      console.error("GET_USER_DASHBOARD-> Error:", error);
    }
  }

  // ✅ FIXED: Load data on mount with unified loading
  useEffect(() => {
    if (window.location.href.includes("timesheets") && loginData?.userInformation?.UserId) {
      loadAllInitialData();
      getTimeSheetGoalFlag();
    }
  }, [loadAllInitialData, loginData?.userInformation?.UserId]);

  // ✅ Event handlers using utilities
  const onGoalPressed = (item) => {
    const isClockInMode = selectedClockInJob?.[0]?.from === "clockin";
    const currentData = isClockInMode ? selectedClockInJob : selectedJob;
    const setCurrentData = isClockInMode ? setSelectedClokInJob : setSelectedJob;

    if (indexForGoal === undefined || !currentData[indexForGoal]) {
      console.error("Invalid IndexForGoal Or Missing Job Entry");
      return;
    }

    const updatedData = updateGoalInJobArray(
      currentData,
      indexForGoal,
      goalIndex,
      item,
      currentData[indexForGoal].isJobItemAddGoalClicked
    );

    setCurrentData(updatedData);
    setShowGoalModal(false);
  };

  const onCategoryPressed = (item) => {
    const isClockInMode = selectedClockInJob?.[0]?.from === "clockin";
    const currentData = isClockInMode ? selectedClockInJob : selectedJob;
    const setCurrentData = isClockInMode ? setSelectedClokInJob : setSelectedJob;

    if (indexForGoal === undefined || !currentData[indexForGoal]) {
      return;
    }

    const updatedData = [...currentData];
    if (!updatedData[indexForGoal].timesheetGoalsArray) {
      updatedData[indexForGoal].timesheetGoalsArray = [];
    }

    const goalArray = updatedData[indexForGoal].timesheetGoalsArray;
    const categoryData = {
      goalName: "",
      time: "00:00",
      goalId: item.goalId,
      categoryName: item.categoryName,
      categoryId: item.id,
      goalDateTimeModal: false
    };

    if (updatedData[indexForGoal]?.isJobItemAddGoalClicked) {
      goalArray.push(categoryData);
    } else if (goalArray[goalIndex]) {
      Object.assign(goalArray[goalIndex], categoryData);
    }

    setCurrentData(updatedData);
    setShowGoalModal(false);
  };

  // ✅ FIXED: Simple event handlers with proper loading states
  const getTimsheetlist = (flag) => {
    setActivelist(flag);
    fetchTimesheets(flag, false); // Not initial load, so show individual loading
    setSelectedTimesheets([]);
  };

  const handleCheckboxChange = (item, isChecked) => {
    setSelectedTimesheets((prev) =>
      isChecked ? [...prev, item] : prev.filter((id) => id !== item)
    );
  };

  const onTimesheetViewclick = async (e, item) => {
    setSeletetdTimesheet(item);
    setOpenModal(true);
    setOperation("edit");
    setSelectedTimesheets((prev) => prev.filter((id) => id !== item));
  };

  const handleSendClick = (value) => {
    if (value?.length > 0) setSelectedTimesheets(value);
    if (selectedTimesheets.length > 0 || value?.length > 0) {
      setShowsend(true);
    }
  };

  const handleCardClick = (item, index, type) => {
    if (type === "inprocess") {
      setSeletetdClockINTimesheet(item);
      setSelectedIndex(index);
      setOpenClockIn(true);
      setOperation("edit");
      setIsClockin(true);
    } else {
      onTimesheetViewclick(null, item);
    }
  };

  const addUser = () => {
    setInitialUser({});
    setOperation("add");
    setAnchorEl(null);
    setOpenDialog(true);
    setSeletetdTimesheet(null);
  };

  const onClickCockin = () => {
    setIsClockin(true);
    setInitialUser({});
    setOperation("add");
    setAnchorEl(null);
    setSeletetdClockINTimesheet(null);
    setOpenClockIn(true);
    setSeletetdTimesheet(null);
  };

  const handleAddGoal = () => {
    setCurrentEditGoal(null);
    setShowAddGoalModal(true);
  };

  const onEditGoalClick = (item) => {
    setCurrentEditGoal(item);
    setShowAddGoalModal(true);
  };

  const onToggleSwitch = async (value) => {
    try {
      setLoadingGoal(true);
      setIsHideCompletedGoals(value);

      const updateFlagPayload = { CreatedBy: loginData?.userInformation?.UserId };
      const fetchGoalsPayload = buildGoalRequestPayload(loginData?.userInformation?.UserId);

      await Postrequestcall(UPDATE_IS_GOAL_FLAG, updateFlagPayload, loginData?.accessToken);
      const goalsResponse = await Postrequestcall(
        FETCH_GOALS,
        fetchGoalsPayload,
        loginData?.accessToken
      );

      setUserGoalData(goalsResponse?.data?.data ?? []);
      setEditGoalModal(false);
    } catch (error) {
      console.error("Error updating goal flag:", error);
    } finally {
      setLoadingGoal(false);
    }
  };

  const onCloseBannerPressed = async () => {
    try {
      const obj = {
        Id: loginData?.userInformation?.UserId,
        IsTimeSheetsBannerFlag: false
      };
      await Postrequestcall(UPDATE_IS_TIMESHEETS_BANNER_FLAG, obj, loginData?.accessToken);
      setIsTimeSheetsBannerFlag(false);
    } catch (error) {
      console.log("Error updating banner flag:", error);
    }
  };

  const onDataSave = async () => {
    await getUsersGoal();
    await getTimesheetgoaldetail();
    setIsTimeSheetsBannerFlag(false);
  };

  const isSendButtonEnabled = selectedTimesheets.length > 0;

  // ✅ FIXED: Show unified loader during initial load
  if (isInitialLoading) {
    return (
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
        <Grid
          pb={1.5}
          container
          spacing={1}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}>
          <Pageheader headerName={TEXT_TIMESHEETS_TITLE} />
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh"
          }}>
          <Loader />
        </Box>
      </Box>
    );
  }

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Grid
        pb={1.5}
        container
        spacing={1}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}>
        <Pageheader headerName={TEXT_TIMESHEETS_TITLE} />
      </Grid>

      <Grid
        className={"main-content-timesheet-card"}
        sx={{ height: isSmallScreen ? "auto" : "100%" }}
        container
        spacing={{ xs: 1, md: 2 }}>
        <Grid
          sx={{ mt: 0, height: isSmallScreen ? "auto" : isMediumScreen ? "auto" : "100%" }}
          className="main-content-card-timesheet"
          size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
          <GoalListAndEdit
            isTimeSheetsBannerFlag={isTimeSheetsBannerFlag}
            onCloseBannerPressed={onCloseBannerPressed}
            handleAddGoal={handleAddGoal}
            goallist={goallist}
            isProgressBarExpanded={isProgressBarExpanded}
            setIsProgressBarExpanded={setIsProgressBarExpanded}
            onEditGoalClickModal={() => setEditGoalModal(!editGoalModal)}
            editGoalModal={editGoalModal}
            onToggleSwitch={onToggleSwitch}
            isHideCompletedGoals={isHideCompletedGoals}
            loadingGoal={loadingGoal}
            userGoalData={userGoalData}
            onEditGoalClick={onEditGoalClick}
            setEditGoalModal={setEditGoalModal}
            isSmallScreen={isSmallScreen}
          />
          <AdContainer />
        </Grid>

        <Grid
          sx={{ mt: 0, height: isSmallScreen ? "auto" : isMediumScreen ? "auto" : "100%" }}
          className="main-content-card-timesheet"
          size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}>
          <Stack
            sx={{ mb: isSmallScreen ? 1 : 1.5 }}
            direction={{ xs: "column", sm: "row" }}
            justifyContent={"space-between"}
            spacing={1}>
            <Stack direction={"row"}>
              <Button
                size="small"
                className={`active-btn ${activeList === "all" ? "active" : ""}`}
                onClick={() => getTimsheetlist("all")}>
                {TEXT_ALL}
              </Button>
              <Button
                size="small"
                className={`active-btn ${activeList === "unsent" ? "active" : ""}`}
                onClick={() => getTimsheetlist("unsent")}>
                {TEXT_UNSENT}
              </Button>
              <Button
                size="small"
                className={`active-btn ${activeList === "sent" ? "active" : ""}`}
                onClick={() => getTimsheetlist("sent")}>
                {TEXT_SENT}
              </Button>
            </Stack>
            <Stack direction={"row"} spacing={{ xs: 1 }}>
              <Button
                size="small"
                variant="contained"
                onClick={(e) => setAnchorEl(e.currentTarget)}>
                {BUTTON_ADD_TIMESHEET}
              </Button>

              <Button
                className="active-btn"
                variant="contained"
                onClick={handleSendClick}
                sx={{
                  background: isSendButtonEnabled ? BIBlue : undefined,
                  width: { xs: "auto", sm: "auto" }
                }}
                disabled={!isSendButtonEnabled}>
                {BUTTON_SEND}
              </Button>
            </Stack>
          </Stack>

          <Box className="main-content-card-list">
            {loading ? (
              <Loader />
            ) : (
              <>
                {timeSheetlist?.length === 0 && retrievedData.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%"
                    }}>
                    <Emptydata
                      icon={<CalendarMonthIcon className="emptydata-icon" />}
                      firstText={TEXT_EMPTY_TIMESHEETS_PLACEHOLDER}
                    />
                  </Box>
                ) : (
                  <List disablePadding>
                    <Stack gap={1}>
                      {/* In Process Section */}
                      {timeSheetlist
                        .filter((item) => item.timesheetStatus === false)
                        .map((item, index) => (
                          <TimesheetCard
                            key={`inprocess-${index}`}
                            item={item}
                            index={index}
                            type="inprocess"
                            selectedTimesheets={selectedTimesheets}
                            onCheckboxChange={handleCheckboxChange}
                            onCardClick={handleCardClick}
                            TEXT_IN_PROGRESS={TEXT_IN_PROGRESS}
                          />
                        ))}
                      {/* Unsent Section */}
                      {timeSheetlist
                        .filter((item) => item.isSent === false && item.timesheetStatus !== false)
                        .map((item, index) => (
                          <TimesheetCard
                            key={`unsent-${index}`}
                            item={item}
                            index={index}
                            type="unsent"
                            selectedTimesheets={selectedTimesheets}
                            onCheckboxChange={handleCheckboxChange}
                            onCardClick={handleCardClick}
                            TEXT_IN_PROGRESS={TEXT_IN_PROGRESS}
                          />
                        ))}
                      {/* Sent Section */}
                      {timeSheetlist
                        .filter((item) => item.isSent === true && item.timesheetStatus !== false)
                        .map((item, index) => (
                          <TimesheetCard
                            key={`sent-${index}`}
                            item={item}
                            index={index}
                            type="sent"
                            selectedTimesheets={selectedTimesheets}
                            onCheckboxChange={handleCheckboxChange}
                            onCardClick={handleCardClick}
                            TEXT_IN_PROGRESS={TEXT_IN_PROGRESS}
                          />
                        ))}
                    </Stack>
                  </List>
                )}
              </>
            )}
          </Box>
          <AdContainer />
        </Grid>
      </Grid>

      {/* 🎯 All your existing modals remain the same */}
      <SendTimesheet
        open={showSend}
        onClose={() => setShowsend(false)}
        selectedTimesheets={selectedTimesheets}
        loginData={loginData}
        onSendComplete={async () => {
          await fetchTimesheets(activeList);
          setOpenModal(false);
          setSelectedTimesheets([]);
        }}
      />

      <TimesheetViewModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        seletetdTimesheet={seletetdTimesheet}
        loginData={loginData}
        isSmallScreen={isSmallScreen}
        onEdit={(detail, timeSheetEnteries) => {
          setIsContext(true);
          setOperation("edit");
          setInitialUser(detail);
          setSelectedJob([...timeSheetEnteries]);
          setOpenDialog(true);
          setOpenModal(false);
        }}
        onSend={(timesheetDetail) => {
          handleSendClick(timesheetDetail);
        }}
        onPictureViewerOpen={(pictures, index) => {
          setImageArray(pictures);
          setImageIndex(index);
          setPictureViewer(true);
        }}
        onDeleteComplete={async () => {
          await fetchTimesheets(activeList);
        }}
      />

      <AddEditTimesheetModel
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setIsContext(false);
          setSelectedJob([]);
          setSelectedIndex(undefined);
          setIsContext(false);
          setIsClockin(false);
        }}
        operation={operation}
        initialUser={initialUser}
        selectedJob={selectedJob}
        setSelectedJob={setSelectedJob}
        loginData={loginData}
        goallist={goallist}
        userGoalData={userGoalData}
        isSmallScreen={isSmallScreen}
        onGoalModalOpen={() => setShowGoalModal(true)}
        onPictureViewerOpen={(pictures, index) => {
          setImageArray(pictures);
          setImageIndex(index);
          setPictureViewer(true);
        }}
        onSaveComplete={async () => {
          await fetchTimesheets(activeList);
          await getUsersGoal();
          setSelectedClokInJob([]);
          setSelectedIndex(undefined);
          setIsContext(false);
        }}
        deletedEntries={deletedEntries}
        setDeletedEntries={setDeletedEntries}
        deletedImages={deletedImages}
        setDeletedImages={setDeletedImages}
        deletedGoalsCategories={deletedGoalsCategories}
        setDeletedGoalsCategories={setDeletedGoalsCategories}
        onJoblistOpen={() => setShowJoblist(true)}
      />

      <GoalsList
        open={showGoalModal}
        onClose={() => setShowGoalModal(false)}
        goallist={goallist}
        onGoalPressed={onGoalPressed}
        onCategoryPressed={onCategoryPressed}
      />

      <AddClockIn
        open={openClockIn}
        onClose={async () => {
          await fetchTimesheets(activeList);
          setIsClockin(false);
          setOpenClockIn(false);
          setSelectedClokInJob([]);
          setSeletetdTimesheet(null);
          setOperation("add");
          setSeletetdClockINTimesheet(null);
          setSelectedIndex(undefined);
        }}
        seletetdClockInTimesheet={seletetdClockInTimesheet}
        operation={operation}
        selectedClockInJob={selectedClockInJob}
        setSelectedClokInJob={setSelectedClokInJob}
        loginData={loginData}
        goallist={goallist}
        isSmallScreen={isSmallScreen}
        onSaveComplete={async () => {
          await fetchTimesheets(activeList);
          setOpenClockIn(false);
          setSelectedClokInJob([]);
          setSeletetdClockINTimesheet(null);
          setSelectedJob([]);
          setSelectedIndex(undefined);
        }}
        onDeleteComplete={async () => {
          await fetchTimesheets(activeList);
          setOpenClockIn(false);
          setSelectedClokInJob([]);
          setSeletetdClockINTimesheet(null);
          setSelectedIndex(undefined);
        }}
        onGoalModalOpen={() => setShowGoalModal(true)}
        onJoblistOpen={() => setShowJoblist(true)}
      />

      <AddGoalModal
        open={showAddGoalModal}
        onClose={() => setShowAddGoalModal(false)}
        editGoalDetails={currentEditGoal}
        loginData={loginData}
        onDataSave={onDataSave}
      />

      {showJoblist && (
        <Joblist
          open={showJoblist}
          onClose={() => setShowJoblist(false)}
          loginData={loginData}
          selectedJob={selectedJob}
          setSelectedJob={setSelectedJob}
          selectedClockInJob={selectedClockInJob}
          setSelectedClokInJob={setSelectedClokInJob}
          isClockIn={isClockIn}
          seletetdClockInTimesheet={seletetdClockInTimesheet}
          roleIndex={1}
          deletedEntries={deletedEntries}
          setDeletedEntries={setDeletedEntries}
        />
      )}

      <ExportGoalsSummaryModal userGoalData={userGoalData} loginData={loginData} />

      {/* Add/Clock-in Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        TransitionComponent={Fade}>
        <MenuItem onClick={addUser}>
          <AddCircleOutlineIcon fontSize="small" sx={{ mr: 1 }} />
          {TEXT_NEW_TIMESHEET}
        </MenuItem>
        <MenuItem onClick={onClickCockin}>
          <AccessTimeIcon fontSize="small" sx={{ mr: 1 }} />
          {TEXT_ADD_CLOCKIN}
        </MenuItem>
      </Menu>

      {/* Picture Viewer */}
      <PictureViewer
        isOpen={pictureViewerOpen}
        onClose={() => setPictureViewer(false)}
        pictures={imageArray.map((item) => ({
          src: item?.pictureUrl ? item?.pictureUrl : URL.createObjectURL(item)
        }))}
        viewerIndex={imageIndex}
      />
    </Box>
  );
}
